"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerminalT4 = void 0;
const BallScrewElement_1 = require("../BallScrewElement");
const terminalT1_1 = require("./terminalT1");
/**
 * Class to draw a screw
 */
class TerminalT4 extends terminalT1_1.TerminalT1 {
    constructor(two, height, w, w1, d4, w3, thread, selected, position = "right", B, L, T) {
        super(two, height, w, w1, d4, w3, thread, selected, position);
        this.B = L;
        this.L = B;
        this.T = T;
    }
    draw() {
        this.group = super.draw();
        const t1 = new terminalT1_1.TerminalT1(this.two, this.height, this.w, this.w1, this.d4, this.w3, this.thread, this.selected);
        t1.scaleFactor = this.scaleFactor;
        const t1112 = t1.draw();
        this.group.add(t1112);
        const rect = this.two.makeRoundedRectangle(this.w + (this.w1 / 2), t1112.translation.y, this.B, this.L, this.L / 2);
        rect.noFill();
        this.group.add(rect);
        this.registerForQuote([rect], "outerleftsingle", 140, parseFloat(this.selected.B.toString()).toFixed(0).toString() + " X " +
            parseFloat(this.selected.L.toString()).toFixed(0).toString() + " X " +
            parseFloat(this.selected.T.toString()).toFixed(0).toString() + " UNI 6604", this.position === "left");
        this.registerForQuote([rect], "distance", 50, parseFloat(((this.selected.W1 - this.selected.L) / 2).toString()).toFixed(1).toString(), this.position === "left", BallScrewElement_1.BallScrewElement.COLORQUOTE, true, false, parseFloat(((this.selected.W1 - this.selected.L) / 2).toString()).toFixed(1).toString());
        return this.group;
    }
}
exports.TerminalT4 = TerminalT4;
